import React from 'react';
import { Alert, Card, Spinner } from 'react-bootstrap';

import { useFetchUserDbqs } from '../../../services/userDbq';
import DbqLegacyTab from './DbqLegacyTab';
import DbqRequestFlowTab from './DbqRequestFlowTab';

const DbqTab = (props) => {
  const { claimId } = props;
  const { data, isLoading, error } = useFetchUserDbqs(claimId);

  if (isLoading && !data) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <Spinner animation="border" />
          <p className="mt-3 text-muted mb-0">Loading DBQ forms...</p>
        </Card.Body>
      </Card>
    );
  }

  if (error && !data) {
    return (
      <Alert variant="danger" className="mb-0">
        Failed to load DBQ forms. {error?.response?.data?.msg || error?.message}
      </Alert>
    );
  }

  if (data?.dbqRequestFlowEnabled) {
    return <DbqRequestFlowTab {...props} />;
  }

  return <DbqLegacyTab {...props} />;
};

export default DbqTab;
